"use client";
import { trackGoogleAdsFlowEvent } from "@/lib/analytics/googleAds";
import { useState } from "react";
import { sendGTMEvent } from "@next/third-parties/google";
import { createFormFlow, type FlowName } from "@/lib/analytics/formFlow";

export function useFormFlow(name: FlowName) {
    return useState(() => createFormFlow(name, {
        send: event => {
            trackGoogleAdsFlowEvent(event);
            sendGTMEvent(event);
        },
        // Use the existing site's acknowledgement; do not replay pre-consent activity.
        allowed: () => typeof window !== "undefined" && window.localStorage.getItem("cookie-consent") === "true",
        uuid: () => crypto.randomUUID(),
        now: () => new Date().toISOString(),
        page: () => window.location.pathname,
        environment: typeof window !== "undefined" && /^(www\.)?thiscar\.com$/.test(window.location.hostname)
            ? "production" : "development"
    }))[0];
}
